import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import logo from "./assets/Logo.png";
import { Badge } from 'primereact/badge';
import { UPDATE_USERNAME } from './redux/slices/authenticationSlice';
import { useDispatch, useSelector } from 'react-redux';

export const AppTopbar = (props) => {

    const dispatch = useDispatch()
    const userName = useSelector((state) => state.authenticationSlice.username) || localStorage.getItem("username");

    const [inactivityTimeout, setInactivityTimeout] = useState(null);

    const handleLogout = () => {
        localStorage.clear();
        window.localStorage.clear();
        window.location.reload(); // Refresh the page to reflect logout
    };

    const resetInactivityTimer = () => {
        if (inactivityTimeout) {
            clearTimeout(inactivityTimeout);
        }
        const timeout = setTimeout(() => {
            handleLogout();
        }, 30 * 60 * 1000); // 5 minutes in milliseconds
        setInactivityTimeout(timeout);
    };

    useEffect(() => {
        if (userName) {
            dispatch(UPDATE_USERNAME(userName));
        }

        // Add event listeners for user activity
        window.addEventListener('mousemove', resetInactivityTimer);
        window.addEventListener('keydown', resetInactivityTimer);

        // Start the inactivity timer
        resetInactivityTimer();

        // Clean up event listeners and timers on component unmount
        return () => {
            window.removeEventListener('mousemove', resetInactivityTimer);
            window.removeEventListener('keydown', resetInactivityTimer);
            if (inactivityTimeout) {
                clearTimeout(inactivityTimeout);
            }
        };
    }, [dispatch, userName]);

    const handleModuleClick = () => {
        setShowTopBar(true);
    };








    const [showTopBar, setShowTopBar] = useState(false);
    //Custom Dropdown
    const [open, setOpen] = useState(false);
    let menuRef = useRef();
    useEffect(() => {
        let handler = (e) => {
            if (!menuRef.current.contains(e.target)) {
                setOpen(false);
                //console.log(menuRef.current);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => {
            document.removeEventListener("mousedown", handler);
        }

    });
    // return (
    //     <div>
    //         {/* Topbar content */}
    //         <AutoLogout /> {/* This is where AutoLogout is used */}
    //     </div>
    // );
    const handleProfileClick = () => {
        // Handle clicking on the profile option
        // You can navigate to the user profile page or perform other actions
    };
    return (


        <div className="layout-topbar">
            <Link to="/" className="layout-topbar-logo">
                <img src={props.layoutColorMode === 'light' ? logo : logo} alt="logo" />
            </Link>

            <button type="button" className="p-link  layout-menu-button layout-topbar-button" onClick={props.onToggleMenuClick}>
                <i className="pi pi-bars" />
            </button>

            <button type="button" className="p-link layout-topbar-menu-button layout-topbar-button" onClick={props.onMobileTopbarMenuClick}>
                <i className="pi pi-ellipsis-v" />
            </button>

            <ul className={classNames("layout-topbar-menu lg:flex origin-top", { 'layout-topbar-menu-mobile-active': props.mobileTopbarMenuActive })}>

                <div className='menu-container' ref={menuRef}>
                    <div className='menu-trigger' onClick={() => { setOpen(!open) }}>
                        <div className='flex align-items-center'>
                            <Badge severity='success' value={`${userName}`} style={{ fontSize: "0.9rem" }} className="mr-3" />
                            <i className='pi pi-angle-down'></i>
                        </div>
                    </div>

                    <div className={`dropdown-menu ${open ? 'active' : 'inactive'}`} >
                        <ul>
                            <li className='dropdownItem' >
                                <div><a className="color" onClick={handleLogout}> <b className='pi pi-sign-out mr-3'></b><b style={{ cursor: "pointer" }}>Logout</b> </a></div>
                            </li>
                        </ul>
                    </div>
                </div>
            </ul>

        </div>
    );
}
